var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import FormControl from '../FormControl';
import FormHelperText from '../FormHelperText';
import Input from './Input';
import InputAdornment from './InputAdornment';
import InputLabel from '../InputLabel';
/**
 * Pigment [TextField](https://pigment.customink.com/?path=/docs/components-textfield)
 */
var TextField = function (_a) {
  var autoFocus = _a.autoFocus,
    defaultValue = _a.defaultValue,
    disabled = _a.disabled,
    endAdornment = _a.endAdornment,
    error = _a.error,
    focused = _a.focused,
    fullWidth = _a.fullWidth,
    _b = _a.helperText,
    helperText = _b === void 0 ? ' ' : _b,
    id = _a.id,
    inputRef = _a.inputRef,
    label = _a.label,
    labelTooltipText = _a.labelTooltipText,
    maxRows = _a.maxRows,
    minRows = _a.minRows,
    multiline = _a.multiline,
    name = _a.name,
    onBlur = _a.onBlur,
    onChange = _a.onChange,
    onFocus = _a.onFocus,
    onKeyDown = _a.onKeyDown,
    onKeyUp = _a.onKeyUp,
    placeholder = _a.placeholder,
    removeHelperTextSpace = _a.removeHelperTextSpace,
    required = _a.required,
    rows = _a.rows,
    startAdornment = _a.startAdornment,
    _c = _a.type,
    type = _c === void 0 ? 'text' : _c,
    value = _a.value,
    _d = _a.TooltipProps,
    TooltipProps = _d === void 0 ? {} : _d,
    _e = _a.FormHelperTextProps,
    FormHelperTextProps = _e === void 0 ? {} : _e,
    _f = _a.inputProps,
    inputProps = _f === void 0 ? {} : _f,
    _g = _a.InputLabelProps,
    InputLabelProps = _g === void 0 ? {} : _g;
  var startAdornmentComponent = function () {
    return /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, startAdornment);
  };
  var endAdornmentComponent = function () {
    return /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, endAdornment);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    error: error,
    required: required,
    disabled: disabled,
    focused: focused,
    fullWidth: fullWidth
  }, label ? /*#__PURE__*/React.createElement(InputLabel, __assign({
    labelTooltipText: labelTooltipText,
    TooltipProps: TooltipProps,
    disableAnimation: true,
    shrink: true
  }, InputLabelProps), label) : null, /*#__PURE__*/React.createElement(Input, {
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    endAdornment: endAdornment ? endAdornmentComponent() : '',
    fullWidth: fullWidth,
    id: id,
    inputRef: inputRef,
    maxRows: maxRows,
    minRows: minRows,
    multiline: multiline,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    placeholder: placeholder,
    rows: rows,
    startAdornment: startAdornment ? startAdornmentComponent() : '',
    type: type,
    value: value,
    inputProps: inputProps
  }), !removeHelperTextSpace && /*#__PURE__*/React.createElement(FormHelperText, __assign({}, FormHelperTextProps), helperText));
};
export default TextField;